import React from "react";
import {BrowserRouter as Router, Route} from "react-router-dom";
import Detail from "./Detail";
import RatingScriptTag from './RatingScriptTag';

function AppRouter() {
   return (
      <Router>
         <Router>
            <Route path="/:id" component={Detail} />
         </Router>
         {/*<RatingScriptTag />*/}
      </Router>
   );
}

export default AppRouter